// Promoção é ESTADO da peça (migração 018): preco_promocional preenchido e
// abaixo do balcão. O % de desconto NUNCA é gravado (regra 4 do CLAUDE.md) —
// deriva dos dois preços aqui, e só aqui: toda tela que rasura preço passa por
// estas três funções, então a régua do que "conta como promoção" tem um dono.

export interface PrecosPromocionaveis {
  preco_balcao: number | null;
  preco_promocional: number | null;
}

/** Está em promoção DE VERDADE? Par completo e desconto real — o mesmo check
 *  do banco (products_promocao_valida), espelhado para a tela decidir o que
 *  rasurar sem esperar o erro. */
export function emPromocao(p: PrecosPromocionaveis): boolean {
  return p.preco_promocional != null && p.preco_balcao != null
    && p.preco_promocional > 0 && p.preco_promocional < p.preco_balcao;
}

/** O preço que vale AGORA no balcão: promocional se ativo, senão o de tabela.
 *  É o que a Venda pré-preenche — o vendedor não pode cobrar o preço cheio de
 *  uma peça anunciada em promoção por esquecimento. */
export function precoVigente(p: PrecosPromocionaveis): number | null {
  return emPromocao(p) ? p.preco_promocional : p.preco_balcao;
}

/** % de desconto inteiro, para o selo ("−15%"). null sem promoção; pode
 *  arredondar para 0 em desconto simbólico (< 0,5%) — a tela decide se exibe. */
export function descontoPct(p: PrecosPromocionaveis): number | null {
  if (!emPromocao(p)) return null;
  return Math.round((1 - p.preco_promocional! / p.preco_balcao!) * 100);
}
